<div class="ag-custom-loading-cell" style="padding-left: 10px; line-height: 25px;">
    @if (displaySpinner()) {
        <i class="fas fa-spinner fa-pulse"></i>
    }
    <span> {{ loadingMessage() }} </span>
</div>